import GetMethod from "./Get";
import PostMethod from "./Post";
import PutMethod from "./Put";
import PatchMethod from "./Patch";
import DeleteMethod from "./Delete";

const Get = (urlPath) => GetMethod(`${urlPath}`);
const Post = (urlPath, data) => PostMethod(`${urlPath}`, data);
const Put = (urlPath, data) => PutMethod(`${urlPath}`, data);
const Patch = (urlPath, data) => PatchMethod(`${urlPath}`, data);
const Delete = (urlPath, data) => DeleteMethod(`${urlPath}`, data);

const API = {
  Get,
  Post,
  Put,
  Patch,
  Delete,
};

export default API;
